'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { OrderPagesURL } from '@/app/(order)/types';
import { LOGIN_PAGE_BASE_PATH } from '@/app/_utils/session/constants';
import { AppNextLink } from '../app-next-link';
import { Modal } from '../modal';
import { CustomEventType } from '../types';
const AppAuthModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const currentPathname = usePathname();
  const isInOrderPages = currentPathname.includes(OrderPagesURL.CART) || currentPathname.includes(OrderPagesURL.PAYMENT) || currentPathname.includes(OrderPagesURL.SHIPPING);
  const handleClose = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    document.addEventListener(CustomEventType.AuthModal, () => {
      setIsOpen(true);
    });
    return () => {
      document.addEventListener(CustomEventType.AuthModal, () => {
        setIsOpen(false);
      });
    };
  }, []);
  return <Modal handleClose={handleClose} title='ورود به حساب کاربری' width='w-full lg:w-[508px]' className='bottom-0 h-fit' closable={!isInOrderPages} isOpen={isOpen} data-sentry-element="Modal" data-sentry-component="AppAuthModal" data-sentry-source-file="app-auth-modal.tsx">
            <div className='flex flex-col gap-6 p-4'>
                <p className='text-sm text-zinc-600'>مشکلی پیش آمده است. لطفا دوباره وارد شوید.</p>

                <AppNextLink href={`${LOGIN_PAGE_BASE_PATH}?redirectUrl=${isInOrderPages ? OrderPagesURL.CART : currentPathname}`} className='mx-auto p-2 text-brand-primary outline-none' prefetch={false} data-sentry-element="AppNextLink" data-sentry-source-file="app-auth-modal.tsx">
                    ورود به حساب کاربری
                </AppNextLink>
            </div>
        </Modal>;
};
export default AppAuthModal;